import { Grid } from '@mantine/core';
import React from 'react';
import { WidgetConfig } from '../../components/elements/Draggable';
import ChartTSI from './ChartTSI';
import ChartCTM from './ChartCTM';
import ChartBudget from './ChartBudget';
import ChartRater from './ChartRater';
import ChartProgramMonitoring from './ChartProgramMonitoring';

interface WidgetListProps {
  itemsList: WidgetConfig[];
  startDate: string;
  endDate: string;
  categoryId: string;
  yearFrom: string;
  yearTo: string;
  typeTask: string;
}

const WidgetList: React.FC<WidgetListProps> = ({
  itemsList,
  categoryId,
  startDate,
  endDate,
  yearFrom,
  yearTo,
  typeTask
}) => {
  return (
    <Grid grow mt={24}>
      {itemsList.map((item, index) => {
        if (item.typeDataChart === 'TSI' && item.display) {
          return (
            <ChartTSI
              title={'Training Satisfaction Index'}
              key={index}
              startDate={startDate}
              endDate={endDate}
            />
          );
        }
        if (item.typeDataChart === 'CTM' && item.display) {
          return (
            <ChartCTM
              title={'Career Track Monitoring'}
              key={index}
              yearFrom={yearFrom}
              yearTo={yearTo}
              typeTask={typeTask}
            />
          );
        }

        if (item.typeDataChart === 'Budget' && item.display) {
          return (
            <ChartBudget
              title={'Training Budget Realization'}
              key={index}
              startDate={startDate}
              endDate={endDate}
            />
          );
        }

        if (item.typeDataChart === 'CPM' && item.display) {
          return (
            <ChartProgramMonitoring
              title={'Program Monitoring'}
              key={index}
              startDate={startDate}
              endDate={endDate}
            />
          );
        }

        if (item.typeDataChart === 'Rater' && item.display) {
          return (
            <ChartRater
              title={'Customer Satisfaction Index (RATER)'}
              key={index}
              yearFrom={yearFrom}
              yearTo={yearTo}
            />
          );
        }

        return null;
      })}
    </Grid>
  );
};

export default WidgetList;
